import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, Stack } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export default function SentMessagesFilters({ selectedMonth, onChangeMonth, isMobile }) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={0.5}
      sx={{ width: isMobile ? '100%' : 280 }}
    >
      <IconButton
        size="small"
        aria-label="Mês anterior"
        onClick={() => onChangeMonth(selectedMonth.subtract(1, 'month'))}
      >
        <ChevronLeft size={18} />
      </IconButton>

      <DatePicker
        label="Mês"
        views={['month', 'year']}
        value={selectedMonth}
        onChange={onChangeMonth}
        format="MM/YYYY"
        slotProps={{ textField: { fullWidth: true, sx: { flex: 1 } } }}
      />

      <IconButton
        size="small"
        aria-label="Próximo mês"
        onClick={() => onChangeMonth(selectedMonth.add(1, 'month'))}
      >
        <ChevronRight size={18} />
      </IconButton>
    </Stack>
  );
}

SentMessagesFilters.propTypes = {
  selectedMonth: PropTypes.object.isRequired,
  onChangeMonth: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
};

SentMessagesFilters.defaultProps = {
  isMobile: false,
};
